import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SquareFootIcon(props: IconProps) {
    return <Icon {...props} iconKey={"square_foot"}/>
}
